import { css, type CSSResult } from '@design.estate/dees-element';

/**
 * Shared visual vocabulary for harness components: card chrome, status
 * pills, and monospace output blocks. Tokens only — both themes flip
 * automatically.
 */
export const harnessCardStyles: CSSResult = css`
  .harness-card {
    border: 1px solid var(--dees-color-border-subtle);
    border-left: 2px solid var(--dees-color-border-default);
    border-radius: var(--dees-radius-lg);
    corner-shape: var(--dees-corner-shape);
    background: var(--dees-color-bg-secondary);
    overflow: hidden;
  }
  .harness-card.status-running,
  .harness-card.status-pending {
    border-left-color: var(--dees-color-accent-primary);
  }
  .harness-card.status-completed {
    border-left-color: var(--dees-color-accent-success);
  }
  .harness-card.status-error {
    border-left-color: var(--dees-color-accent-error);
  }
  .harness-card.destructive {
    border-left-color: var(--dees-color-accent-error);
  }
`;

export const harnessPillStyles: CSSResult = css`
  .harness-pill {
    flex: 0 0 auto;
    padding: 2px 8px;
    border-radius: var(--dees-radius-full);
    background: var(--dees-color-badge-default-bg);
    color: var(--dees-color-badge-default-fg);
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    white-space: nowrap;
  }
  .harness-pill.tone-running,
  .harness-pill.tone-pending {
    background: var(--dees-color-fill-secondary);
    color: var(--dees-color-accent-primary);
  }
  .harness-pill.tone-success {
    background: var(--dees-color-badge-success-bg);
    color: var(--dees-color-badge-success-fg);
  }
  .harness-pill.tone-warning {
    background: var(--dees-color-badge-warning-bg);
    color: var(--dees-color-badge-warning-fg);
  }
  .harness-pill.tone-error {
    background: var(--dees-color-badge-error-bg);
    color: var(--dees-color-badge-error-fg);
  }
`;

export const harnessMonoStyles: CSSResult = css`
  .harness-mono {
    margin: 0;
    padding: var(--dees-spacing-sm) var(--dees-spacing-md);
    border: 1px solid var(--dees-color-border-subtle);
    border-radius: var(--dees-radius-md);
    corner-shape: var(--dees-corner-shape);
    background: var(--dees-color-code-block-bg);
    color: var(--dees-color-text-primary);
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    overflow: auto;
    font-family: var(--dees-font-family-mono);
    font-size: var(--dees-font-control-size-sm, 12px);
    line-height: 1.5;
  }
  .harness-mono.tone-error {
    color: var(--dees-color-text-error);
  }
  .harness-mono-expand {
    margin-top: var(--dees-spacing-xs);
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--dees-color-link);
    cursor: pointer;
    font-size: var(--dees-font-control-size-sm, 12px);
  }
  .harness-mono-expand:hover {
    color: var(--dees-color-link-hover);
    text-decoration: underline;
  }
`;
